import { Box } from "@tokenterminal/ui/Box"
import { PlaceholderText } from "@tokenterminal/ui/Placeholders/Text"
import { mediumChartCss, smallChartCss } from "./DataSnippet.css"
import { PlaceholderPlot } from "./PlaceholderPlot"

const Plot = ({ size }: { size: "s" | "m" }) => {
  return (
    <Box
      className={[
        {
          [mediumChartCss]: size === "m",
          [smallChartCss]: size === "s",
        },
      ]}
    >
      <PlaceholderPlot />
    </Box>
  )
}

type Variant = "normal" | "small plot" | "no plot"

interface BaseProps {}

type Props = BaseProps

const InnerSnippet = () => {
  return (
    <div className="flex flex-col gap-4 justify-between w-full overflow-hidden h-[47px]">
      <PlaceholderText width="100%" />

      <div className="flex gap-1 items-center justify-start w-full">
        <PlaceholderText style={{ width: "30%" }} />
        <PlaceholderText style={{ width: "30%" }} />
      </div>
      <PlaceholderText style={{ width: "50%" }} />
    </div>
  )
}

const NormalPlotSnippet = () => (
  <div className="flex gap-1 items-center justify-start w-full">
    <Plot size="m" />
    <InnerSnippet />
  </div>
)

type DataSnippetProps = Props & {
  variant?: Variant
}

export function DataSnippetPlaceholder({
  variant = "normal",
}: DataSnippetProps) {
  switch (variant) {
    case "small plot":
    case "no plot":
      return <InnerSnippet />
    case "normal":
    default:
      return <NormalPlotSnippet />
  }
}
